import { LeaderboardAd } from '@flix/common/domain/ads/bannerAds/LeaderboardAd'
import { MobileLeaderboard } from '@flix/common/domain/ads/bannerAds/MobileLeaderboard'
import { useBannerAdDecision } from '@flix/common/domain/ads/useBannerAdDecision'
import { useMediaIs } from '@flix/common/style/media'

export const NowShowingLeaderboardAd = ({ zone, placementXs, placementSm }) => {
  const sm = useMediaIs('sm')

  const placement = sm ? placementSm : placementXs

  const bannerDetails = useBannerAdDecision(zone, placement)

  return sm ? (
    <LeaderboardAd data={bannerDetails} mb="xxxlarge" />
  ) : (
    <MobileLeaderboard data={bannerDetails} mb="xxxlarge" />
  )
}
